import { Image, ThemeProvider } from '@change/ds-core-ui/next';

import { useHomepagePageData } from 'src/app/pages/homepageV2/pageContext';

import { SapCtas } from './components/SapCtas';
import { TitleAndTagline } from './components/TitleAndTagline';
import { TopImpactStoriesDesktop } from './components/TopImpactStoriesDesktop';
import { TopImpactStoriesMobile } from './components/TopImpactStoriesMobile';
import { TopImpactStoriesMobileProvider } from './components/TopImpactStoriesMobile/hooks/TopImpactStoriesMobileContext';

function BgImagePreload({ fetchPriority: fetchpriority }: { fetchPriority: string }) {
	return (
		<Image
			src="https://static.change.org/homepageV3/background-globe-sunrise.svg"
			alt="Globe"
			{...(fetchpriority ? { fetchpriority } : {})}
			className="absolute -translate-y-[20%] translate-x-0 overflow-visible bg-transparent object-cover max-md:h-full md:left-1/2 md:top-[15%] md:-translate-x-1/2 md:-translate-y-[30%]"
		/>
	);
}

export const HeroSectionSunrise: React.FC = () => {
	const {
		data: { v3TopImpactStories },
	} = useHomepagePageData();

	return (
		<ThemeProvider>
			<section data-testid="homepage-sunrise-hero-section" className="text-typography-strong relative overflow-hidden">
				<BgImagePreload fetchPriority="high" />

				<div className="container relative z-10 pt-6 md:pt-[44px] lg:pb-11 lg:pt-[60px]">
					<div className="mt-3 space-y-6">
						<TitleAndTagline />
						<SapCtas />
					</div>

					{v3TopImpactStories.length > 0 && <TopImpactStoriesDesktop />}
				</div>

				{v3TopImpactStories.length > 0 && (
					<TopImpactStoriesMobileProvider>
						<TopImpactStoriesMobile />
					</TopImpactStoriesMobileProvider>
				)}
			</section>
		</ThemeProvider>
	);
};
